// Distinguishing, non-spoiling titles for real historical scenarios (details stay hidden until reveal).
const CAT = { UPTREND: "Uptrend", DOWNTREND: "Downtrend", RANGE: "Range", BREAKOUT: "Breakout", REVERSAL: "Reversal" };

const caseNo = (id = "") => (id.match(/(\d+)$/) || [, ""])[1];

export const scenarioTitle = (s) => {
  if (s.is_synthetic) return s.name;
  const cat = CAT[s.category] || (s.category || "Market").replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
  const sym = (s.symbol || "").split("/")[0];
  return `${sym} ${cat} Read · ${s.interval} · Case ${caseNo(s.id) || "—"}`.trim();
};

export const scenarioSubtitle = (s) =>
  [s.difficulty && s.difficulty.toLowerCase(), s.volatility_state && `${s.volatility_state} volatility`]
    .filter(Boolean).join(" · ");
